<!-- grid template -->
<div *ngIf="!loading" class="container mx-auto max-w-5xl">
  <div class="mx-auto my-10 max-w-md text-center">
    <div
      class="bg-gradient-to-r from-primary-darkest to-primary-md-dark bg-clip-text font-playfair-display text-5xl leading-tight text-transparent text-primary-darkest">
      BEAUTY <br />
      BOOK
    </div>
  </div>
  <!-- start selfie section -->
  <div class="my-5 grid grid-cols-1 md:grid-cols-2 md:gap-x-3">
    <div class="flex-row">
      <div class="image relative mx-auto mt-3 max-w-sm md:max-w-xs">
        <img
          class="rounded-r-full rounded-b-full border-2 border-primary-dark"
          [src]="beautybookPost.path"
          [alt]="
            beautybookPost.post_products[0].beautybook_post_product_name
          " />
        <div class="absolute right-0 bottom-1">
          <div
            [routerLink]="[
              '/beautybook/add',
              beautybookPost.post_products[0].beauty_book_product_id
            ]"
            class="hover: flex h-28 w-28 cursor-pointer items-center justify-center rounded-full border-primary-md-dark bg-primary-md-dark text-center font-bold text-white hover:border-2 hover:bg-white hover:text-primary-md-dark md:h-20 md:w-20">
            <div class="px-2 text-xl uppercase md:text-lg">
              Try <br />
              On
            </div>
          </div>
        </div>
      </div>
      <div class="mx-10 px-10 md:mx-5">
        <div class="product mt-3 flex">
          <img
            class="h-24 w-24"
            [src]="
              beautybookPost.post_products[0].beauty_book_product_variant_path
                .small.path
            "
            [alt]="
              beautybookPost.post_products[0].beauty_book_product_variant_name
            " />
          <div class="info">
            <div
              class="variant w-fit rounded-l-full rounded-r-full bg-primary-md-dark px-4 py-1 text-sm text-white">
              {{
                beautybookPost.post_products[0].beauty_book_product_variant_name
              }}
            </div>
            <div
              class="mt-0.5 text-lg font-semibold text-primary-darkest line-clamp-3">
              {{ beautybookPost.post_products[0].beauty_book_product_name }}
            </div>
          </div>
        </div>
        <div class="mt-3 flex justify-center">
          <button
            type="button"
            (click)="addToCart()"
            class="w-full rounded-full bg-primary-darkest px-5 py-3 text-lg font-semibold text-white md:mx-auto md:w-[95%] md:text-sm">
            Add this variant to cart
          </button>
        </div>
        <div
          routerLink="/beautybook/list"
          class="mt-3 cursor-pointer text-center text-primary-darkest hover:text-primary-md-dark">
          See All Beauty Posts
        </div>
      </div>
    </div>
    <!-- end selfie section -->
    <div class="mx-auto mt-5 w-full max-w-xl space-y-4 p-5">
      <div class="flex justify-between space-x-5">
        <div class="flex gap-4">
          <img
            [src]="
              beautybookPost.user?.propic_path
                ? beautybookPost.user?.propic_path
                : 'assets/images/default-user.png'
            "
            class="h-20 w-20 rounded-full md:h-16 md:w-16"
            alt="" />
          <div>
            <div class="text-2xl font-bold text-primary-darkest md:text-xl">
              {{ beautybookPost.user.name }}
            </div>
            <div class="-mt-1 text-lg text-primary-darkest md:text-sm">
              {{ beautybookPost.created_at | date: 'MMM d, y' }}
            </div>
          </div>
        </div>
        <!-- like comment share component -->
        <div class="text-xl md:text-lg">
          <div class="flex gap-4">
            <div class="cursor-pointer space-x-1" (click)="like()">
              <fa-icon
                [icon]="faHeart"
                [ngClass]="
                  beautybookPost.already_like
                    ? 'text-secondary-dark'
                    : 'text-gray-500'
                "></fa-icon>
              <span class="font-semibold text-primary-darkest">{{
                beautybookPost.total_likes
              }}</span>
            </div>
            <div class="space-x-1">
              <fa-icon
                [icon]="faComment"
                class="text-primary-md-dark"></fa-icon>
              <span class="font-semibold text-primary-darkest">{{
                beautybookPost.total_comments
              }}</span>
            </div>
            <div class="cursor-pointer space-x-1" (click)="onShare()">
              <fa-icon [icon]="faShare" class="text-gray-400"></fa-icon>
            </div>
          </div>
        </div>
        <!-- end like comment share component -->
      </div>
      <!-- caption -->
      <div class="rounded-lg bg-gray-100 p-3">{{ beautybookPost.caption }}</div>
      <!-- end caption -->

      <!-- comment input box -->
      <div class="mx-auto mt-5 max-w-2xl">
        <form [formGroup]="beautybookCommentForm" (ngSubmit)="onSubmit()">
          <div class="p-input-icon-right mx-auto w-full flex-1">
            <textarea
              type="text"
              formControlName="comment"
              class="h-full w-full rounded-lg border-[0.5px] border-primary-md-dark py-[7px] px-4 text-primary-md-dark"
              placeholder="What do you think? "
              fcDebounceKeyup></textarea>
          </div>
          <div class="mt-3 flex justify-end">
            <button
              routerLink="/beautybook/detail/1"
              type="submit"
              class="rounded-lg bg-primary-darkest py-3 px-7 font-bold text-white">
              POST
            </button>
          </div>
        </form>
      </div>
      <!-- end comment input box -->
      <hr class="bg-slate-200" />

      <!-- comments -->
      <div *ngFor="let comment of comments">
        <div class="flex gap-4">
          <img
            [src]="
              comment.user?.propic_path
                ? comment.user?.propic_path
                : 'assets/images/default-user.png'
            "
            class="h-10 w-10 rounded-full md:h-11 md:w-11"
            alt="" />
          <div>
            <!-- username comments -->
            <div class="text-lg font-bold text-primary-md-dark">
              {{ comment.user.name }}
            </div>
            <!-- comment box -->
            <div class="rounded-lg bg-gray-100 p-3">{{ comment.comment }}</div>
          </div>
        </div>
      </div>
      <!-- end comments -->
    </div>
  </div>
</div>
<main class="container mx-auto mt-10 flex max-w-5xl gap-10" *ngIf="loading">
  <p-skeleton class="hidden w-[452px] md:block" height="382px"></p-skeleton>
  <div class="flex-1">
    <div class="mb-3 w-[300px]">
      <p-skeleton class="w-full" height="2rem"></p-skeleton>
    </div>
    <div class="mb-3 w-[250px]">
      <p-skeleton class="w-full" height="2rem"></p-skeleton>
    </div>
    <p-skeleton class="mb-5 w-full" height="10rem"></p-skeleton>
  </div>
</main>
